import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  root: {
    position: 'relative',
    maxWidth: '100vw',
    minWidth: '100vw',
    width: '100%',
    height: '30rem',
    flexGrow: 1,
  },
  imgContainer: {
    height: '30rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundColor: theme.bisqueColor,
    zIndex: -1,
  },
  img: {
    width: '100%',
  },
  stepsControl: {
    position: 'absolute',
    top: '0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  btn: {
    fontSize: '1rem',
    fontFamily: theme.fontFamilyArchivo,
    height: '100%',
    width: '18rem',
    color: theme.dimGrayColor,
    backgroundColor: 'transparent',
    border: 'none',
    textTransform: 'uppercase',
    cursor: 'pointer',

    '&:focus': {
      outline: 'none',
    },
    '&:hover': {
      color: theme.whiteColor,
    },
  },
  steps: {
    position: 'absolute',
    right: '4rem',
    top: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '2rem',
    width: '3.75rem',
    color: theme.whiteColor,
    backgroundColor: theme.dimGrayColor,
    borderRadius: '1rem',
  },
}));

export default useStyles;
